import Page from './page/[pageNo]';
import { getUserIds } from '@api';
import { GetStaticPaths } from 'next';

export { getStaticProps } from './page/[pageNo]';
export default Page;

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: (await getUserIds()).map((id) => ({
      params: { id: String(id) },
    })),
    fallback: 'blocking',
  };
};
